<template>
  <div>
      <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    Student Details
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    studentList: "",
    overlay: false,
    snackbar_msg: "",
      color: "",
      snackbar: false,
  }),
  mounted() {
    this.overlay = true;
    axios
      .post("/Tenant/getStudetData")
      .then(res => {
        if (res.data.msg == "200") {
          this.overlay = false;
          this.studentList = res.data.StudList;
          console.log(this.studentList);
        }else{
            this.overlay = false;
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(() => {
        overlay = false;
      });
  },
  methods: {
      showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  }
};
</script>